import { AppBar, IconButton, Avatar, Button, Hidden } from '@mui/material';
import { Menu, NotificationsNone, SettingsOutlined, ArrowBack } from '@mui/icons-material';
import React, { useContext } from "react";

import './hoa-header.scss';
import { GlobalContext } from "../../context/hoa-global-context";

import datastore from '../../store/hoa-datastore';
import useMobileViewEnabled from '../../hooks/useMobileView';

const Header = () => {
    const {
		open,
		toggleDrawer,
		view,
		updateView,
		viewMoreDetails,
		changeActiveMenu,
        activeMenu,
		updateSelectedValues,
		setViewMoreDetails,
        hoa,
        selectedValues,
        updateHoaData,
        property,
        updatePropertyData
	} = useContext<any>(GlobalContext);

    const { isMobileView } = useMobileViewEnabled();

    const onGoBackClick = () => {
        if(Object.keys(viewMoreDetails).length === 0) {
            updateView('back-to-list');
            changeActiveMenu(activeMenu,false, "", -1);
        } else {
            if(viewMoreDetails.prevTagType === 'HOAs') {
                let tmpData = hoa.data;
                const hoaObjectIndex = tmpData.findIndex((h:any,index:number)=>h['municipality'].objectId === viewMoreDetails.prevValues['municipality'].objectId)
                viewMoreDetails.prevValues.municipality = selectedValues;
                tmpData[hoaObjectIndex] = viewMoreDetails.prevValues;
                updateHoaData({
                    ...hoa,
                    data:tmpData
                }) 
            } else if(viewMoreDetails.prevTagType === 'Properties') {
                let tmpData = property.data;
                tmpData[viewMoreDetails.prevIndex] = viewMoreDetails.prevValues;
                updatePropertyData({
                    ...property,
                    data:tmpData
                }) 
            }
            changeActiveMenu(viewMoreDetails.prevTagType,true)
            updateSelectedValues(viewMoreDetails.prevValues)
            setViewMoreDetails({})
        }
    }

    return (
        <AppBar id='header-app-bar'>
            <div className="header-container right">
                {
                    !open &&
                    <IconButton style={{ marginLeft: '12px' }} onClick={toggleDrawer}>
                        <Menu className="header-menu-icon" />
                    </IconButton>
                }
                {view === 'view' && 
                    <div style={{ display:'flex', alignItems:'center'}}>
                        <IconButton
                            onClick={() => onGoBackClick()}
                            style={{ marginLeft: '8px' }}
                        >
                            <ArrowBack style={{ color: '#3576e5' }} />
                        </IconButton>
                        {!isMobileView && <span className="text-3576E5-16px">Go Back</span>}
                    </div>
                }
            </div>
            <div className="header-container left">
                <IconButton>
                    <NotificationsNone className="header-menu-icon" />
                </IconButton>
                <IconButton>
                    <SettingsOutlined className="header-menu-icon" />
                </IconButton>
                <div className="header-profile-container">
                    <Avatar style={{ width:'32px', height:'32px'}} alt="Remy Sharp" src={datastore.ownerInformation.img} />
                    <span className="header-title-profile">{datastore.ownerInformation.name}</span>
                </div>
            </div>
        </AppBar>
    )
}


export default Header;